"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringDateString = exports.sge2Date = exports.parseDateString = void 0;
const date_fns_1 = require("date-fns");
const yup = __importStar(require("yup"));
const parseDateString = (value, originalValue) => {
    if (!originalValue)
        return undefined;
    const parsedDate = (0, date_fns_1.parseISO)(originalValue);
    if (!(0, date_fns_1.isValid)(parsedDate))
        return 'Data inválida.';
    if (originalValue.length <= 10)
        parsedDate.setHours(12, 0, 0);
    // eslint-disable-next-line prettier/prettier
    value = (0, date_fns_1.format)(parsedDate, 'yyyy-MM-dd\'T\'HH:mm:ss');
    return value;
};
exports.parseDateString = parseDateString;
const sge2Date = () => yup
    .string()
    .transform(exports.parseDateString)
    .test('Valid', 'A data é inválida', (val) => {
    return (0, exports.parseDateString)('', val || '') !== 'Data inválida.';
});
exports.sge2Date = sge2Date;
const stringDateString = (originalValue) => {
    if (!originalValue)
        return '';
    const parsedDate = (0, date_fns_1.parseISO)(originalValue);
    if (!(0, date_fns_1.isValid)(parsedDate))
        return 'Data inválida.';
    parsedDate.setHours(12, 0, 0);
    // eslint-disable-next-line prettier/prettier
    return (0, date_fns_1.format)(parsedDate, 'yyyy-MM-dd\'T\'HH:mm:ss');
};
exports.stringDateString = stringDateString;
